import { render } from "./MModal.vue?vue&type=template&id=93dca8f6"
import script from "./MModal.vue?vue&type=script&lang=js"
export * from "./MModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__